// eslint-disable-next-line no-unused-vars
const canRequire = typeof __webpack_require__ === 'function';

module.exports =
{
    branding: 'heute', // 'heute', 'logo'
    theme: 'dark', // 'dark', 'light'
    // Meta Tags für Facebook, Twitter
    meta: {
        // Seiten Title
        title: 'Wie Trump das Weiße Haus umgestaltet – eine interaktive 3D-Story',
        // Beschreibung
        description: 'Ballsaal, Gold und Bodenbelag für Stöckelschuhe: Donald Trump gestaltet das Weiße Haus um. Erkunden Sie interaktiv, welche Maßnahmen der US-Präsident schon durchgeführt hat und was er noch plant.',
        // Bild
        image: 'https://3d.zdf.de/trump-weisses-haus-umbau/img/social_card.jpg',
        // URL
        url: 'https://3d.zdf.de/trump-weisses-haus-umbau/',
    },
    tracking: {
        storyName: 'Trump Ballsaal',
        storyID: '3DS Trump Ballsaal',
        // Tracking deaktivieren
        //disabled: true,
    },
    babylon: {
        lightIntensity : 1,

        camera: {
            // Position, Ausrichtung und Kamera Bewegung
            // Kamera Position
            position: [.5 * Math.PI, .45 * Math.PI, 15], // alpha, beta, radius
            moveFunction: 'move', // Wie die Kamera bewegt wird: 'move' Kamerafahrt, 'set' Springt zur Position
            target: [0, 0, 0], // Wohin die Kamera blickt
            animationSpeed: 280, // Geschwindigkeit der Kamerabewegung

            // Begrenzungen
            alphaLimits: [null, null],
            betaLimits: [0.1, Math.PI / 2],
            radiusLimits: [5, 100], // minCamRadius, maxCamRadius
            clipping: [1, 10000.0],
            fov: 0.8,
            invertRotation: false, // Kamera Steuerung umkehren für 360° Sphere Ansicht
            stopOnClick: true, // Kamera Animation stoppen, bei klick

            // Automatisches Drehen
            useAutoRotationBehavior: false,
            idleRotationSpeed: 0.05,

            // Steuerung
            panSensibility: 0, // 0 is deactivated
            wheelPrecision: 25.0, // 3.0 ist Standard
        },
    },
    audio: {
        enabled: true,
        // Dauerhafte Hintergrund Musik
        //background: canRequire && require('./assets/audio/News_Loop3.mp3'),
    },
    objects:
    [
        {
            name: "zdfLogo",
            filename: "ZDF_Logo.glb",
            options: {
                // true: Objekt anzeigen
                visible: false,

                // Skalierung: Objekt Größe ändern in allen Dimensionen
                scaling: [1, 1, -1],

                // Skalierung: Objekt Größe ändern (Alle Dimensionen gleich)
                //scale: 0.01,

                // Position
                position: [0, 0, 0],

                // Rotation
                rotation: [0.5 * Math.PI, 0, 0],
        
                // Rotation Quaternion, siehe https://doc.babylonjs.com/features/position,_rotation,_scaling#rotationquaternion
                //rotationQuaternion: [0.707, 0, 0, 0.707],

                // Transparenz (0 bis 1)
                //visibility: 0.25,

                // RGB-Farbe (diffuse) jeweils Werte 0 bis 255
                //diffuse: [255, 0, 0],

                // Zur Kamera ausrichten
                // 1: X-Achse, 2: Y-Achse, 4: Z-Achse, 7: Alle Achsen
                // 3: X & Y-Achse, 5: Z & X-Achse, 6: Z & Y-Achse
                // https://doc.babylonjs.com/typedoc/classes/babylon.abstractmesh#billboardmode
                billboardMode: 0,

                // Overlay Color zum hervorheben von Objekten
                //overlayColor: [250/255, 125/255, 25/255],

                // Rendering Group ID legt Objekte eine ebene nach vorne (Auch beim Hotspot)
                //renderingGroupId: 1

                //// MeshObject
                // Objekt mit Fade ein und ausblenden, wenn visible sich ändert
                fade: false,

                // Unter-Mesh-Objekte in der Datei

                ZDF_Logo: {
                    visible: true,
                    fade: false,
                    // Ist das Objekt anklickbar?
                    // Bei true wird ein Hotspot durch das Objekt nicht anklickbar, wenn verdeckt.
                    // Darum sollte bei transparenten Objekten ggf. pickable: false gesetzt werden.
                    pickable: true,
                    
                    // Texture auf Objekt durchgehend verschieben. Zum Beispiel für Lava oder Wasser.
                    // Die zwei Werte geben die Verschiebung-Geschwindigkeit pro Achse an.
                    //animateTexture: [ -0.001, 0 ],

                    ZDF_Logo_2: {
                        visible: true,
                        fade: false,
                    }
                },

                //// BabylonObject
                // animation=true: startet die Animation im Objekt
                animation: false,

                // Nur initial, nicht per babylonState
                // OnClick Trigger
                // trigger: function () { }
            },
            // Callback wenn Objekt geladen und erstellt wurde zum setzen weiterer Einstellungen.
            callback: function (zdfLogo) // eslint-disable-line no-unused-vars
            {

            }
        },

        //--- KARTEN ---
        {
            name: "Karten",
            filename: "Karten.glb",

            options: {
                visible: false,
                position: [0, 0, 0],
                scaling: [-1, 1, 1],
                rotation: [0, 0, 0],

                //-- Meshes --
                Karte_all: {visible: false},
                Karte_ostfluegel: {visible: false},
                Karte_ostfluegel_transparent: {visible: false},
                Karte_weissesHaus: {visible: false},
            },
        },

        //--- WEISSES HAUS ---
        {
            name: "WeissesHaus",
            filename: "WeissesHaus.glb",

            options: {
                visible: true,
                position: [0, 0, 0],
                scaling: [-1, 1, 1],
                rotation: [0, 0, 0],
            },
        },

        {
            name: "Ostfluegel_alt",
            filename: "Ostfluegel_alt.glb",

            options: {
                visible: true,
                position: [0, 0, 0],
                scaling: [-1, 1, 1],
                rotation: [0, 0, 0],
            },
        },

        {
            name: "Ostfluegel",
            filename: "Ostfluegel.glb",

            options: {
                visible: false,
                position: [0, 0, 0],
                scaling: [-1, 1, 1],
                rotation: [0, 0, 0],

                //-- Meshes --
                Ostfluegel: {
                    Ostfluegel_shadow: {position: [0, 0.047, 0]},
                },
            },
        },

        {
            name: "Ostfluegel_transparent",
            filename: "Ostfluegel_transparent.glb",

            options: {
                visible: false,
                position: [0, 0, 0],
                scaling: [-1, 1, 1],
                rotation: [0, 0, 0],
            },
        },


        //--- EXTRAS ---
        {
            name: "Groessenvergleich",
            filename: "Groessenvergleich.glb",

            options: {
                visible: false,
                position: [0, 0, 0],
                scaling: [-1, 1, 1],
                rotation: [0, 0, 0],

                Ostfluegel_alt_Umriss: {},
                Ostfluegel_Umriss: {},
                
                Labels: {
                    Label_Haupthaus: {
                        position: [0, -2.5, 0],
                        scaling:[1,-1,-1],
                        pickable: false,
                    },

                    Label_Westfluegel: {
                        position: [4.8, -1.8, 1.3],
                        scaling:[1,-1,-1],
                        pickable: false,
                    },

                    Label_Ostfluegel: {
                        position: [-4, -1.8, 0.7],
                        scaling:[1,-1,-1],
                        pickable: false,
                    },
                },
            },

            callback: function (Groessenvergleich) // eslint-disable-line no-unused-vars
            {
                //-- Materials unlit setzen
                let MAT_ZDFweiss = this.scene.getNodeByName("Label_Haupthaus").material;
                MAT_ZDFweiss.disableLighting = true;

                let MAT_ZDFblau = this.scene.getNodeByName("Label_Haupthaus_Text").material;
                MAT_ZDFblau.disableLighting = true;

                let MAT_ZDForange = this.scene.getNodeByName("Ostfluegel_alt_Umriss").material;
                MAT_ZDForange.disableLighting = true;
            },
        },

         {
             name: "lava",
             filename: "lava_keyframes_code_philipp.glb", // https://3d.zdf.de/coronavirus/3d-models/mdl_virus_016.glb
             options: {
                 visible: false,
                 position: [0, 0, 0],
                 scaling: [.1, .1, .1],
                 rotation: [0, 0, 0],
             },
         },
    ]
};
